// validationSchema.ts
import * as yup from 'yup'

export const schemaCreateFO = yup.object({
  name: yup.string().required('Tên Flash offer là bắt buộc'),
  started_at: yup.string().required('Thời gian bắt đầu là bắt buộc'),
  ended_at: yup.string().required('Thời gian kết thúc là bắt buộc'),
  status: yup.string().required('Trạng thái là bắt buộc'),
  deposit: yup.number().required('Tiền cọc là bắt buộc'),
  province_id: yup.string().required('Tỉnh/Thành phố là bắt buộc'),
  ward_id: yup.string().required('Xã/Phường là bắt buộc'),
  real_estate_ids: yup.array().of(yup.number()).min(1, 'Danh sách sản phẩm là bắt buộc'),

  // items: yup.array().of(yup.object({
  //   province_id: yup.string().required('Tỉnh/Thành phố là bắt buộc'),
  //   district_id: yup.string().required('Quận/Huyện là bắt buộc'),
  //   ward_id: yup.string().required('Phường/Xã là bắt buộc'),
  //   price_from: yup.number().required('Giá từ là bắt buộc'),
  //   price_to: yup.number().required('Giá đến là bắt buộc'),
  //   real_estate_ids: yup.array().of(yup.number()).required('Danh sách sản phẩm là bắt buộc'),
  //   deposit: yup.number().required('Tiền đặt cọc là bắt buộc'),
  // })),
})
